import is from '@sindresorhus/is';
import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useRef } from 'react';
import type { StoreApi } from 'zustand';

import type { AlignmentStore } from './alignment-store';
import { createAlignmentStore } from './alignment-store';

export const AlignmentContext = createContext<StoreApi<AlignmentStore> | null>(null);

export const AlignmentContextProvider: FunctionComponent<PropsWithChildren> = (properties) => {
    const storeRef = useRef<StoreApi<AlignmentStore>>(undefined);

    if (is.undefined(storeRef.current)) {
        storeRef.current = createAlignmentStore();
    }

    return <AlignmentContext.Provider value={storeRef.current}>{properties.children}</AlignmentContext.Provider>;
};
